import { resetConnectionLossGuard } from './errorRequestHandler';

export const transformHttpResponse = response => {
    const {status, data} = response;
    if (status >= 200 && status < 300) {
        // A request that got through means the connection is back, so the next
        // outage is announced again. See the guard in errorRequestHandler.
        resetConnectionLossGuard();

        return response
    } else {
        const error = new Error(response.statusText);
        error.status = status;
        error.data = data;
        throw error
    }
};
